import Button from 'components/Button/index'
import Drawer from 'components/Drawer'
import Checkbox from 'components/Form/Checkbox'
import AttachFiliIcon from 'components/icons/AttachFiliIcon'
import DownLoad from 'components/icons/DownLoad'
import FileEditIcon from 'components/icons/FileEditIcon'
import {
  CheckBoxDiv,
  CheckBoxFlex,
  ContentDiv,
  ContentInfo,
  DateDiv,
  DownLoadFlex,
  FileDiv,
  FileFlex,
  FooterFlex,
  HeaderPartDiv,
  LogoDiv,
  LogoFlex,
  LogoNameSpan,
  RadioDiv,
  TitleSpan,
  TopFlex,
} from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ReleaseOfferDrawer/PreviewOfferLetter/style'
import React from 'react'
const PreviewOfferLetter = ({ offerLetter, setOfferLetter }) => {
  const content = () => {
    return (
      <>
        <TopFlex spaceBetween alignCenter>
          <FileFlex>
            <AttachFiliIcon />
            <FileDiv>Offerletter.pdf</FileDiv>
          </FileFlex>
          <DownLoadFlex>
            <FileEditIcon />
            <DownLoad />
          </DownLoadFlex>
        </TopFlex>
        <HeaderPartDiv>
          <LogoFlex spaceBetween alignCenter>
            <LogoDiv>
              <LogoNameSpan>Corporate Logo</LogoNameSpan>
            </LogoDiv>
            <DateDiv>Date: 25/06/2022</DateDiv>
          </LogoFlex>
          <ContentInfo>
            <ContentDiv>
              Dear <TitleSpan> Vikas Sharma,</TitleSpan>
            </ContentDiv>
          </ContentInfo>
          <ContentDiv>
            We are pleased to offer you the full-time position of Software
            Engineer at [company name] with a start date of July 15th, 2019,
            contingent upon a background check and completion of the I9 tax
            form. [manager/supervisor name] at [workplace location] will be your
            primary contact and manager on site. It is in our opinion that your
            abilities and experience will be the perfect fit for our company. In
            this role, you will build and maintain low latency, high performance
            scalable systems, design, implement, and scale new APIs, aggregation
            services, and data centric microservices, and solve interesting
            scaling problems.
            <TitleSpan>Compensation: </TitleSpan>The starting annual salary for
            this position is $85,000 to be paid on a weekly basis by direct
            deposit starting on July 22nd, 2019. This salary also includes stock
            options.
            <TitleSpan>Joining Bonus:</TitleSpan> In addition, you will be
            eligible to be considered for an incentive bonus for each fiscal
            year of the company. Your target bonus will be paying out up to
            $5,000 as a joining bonus., Your employment with [company name] will
            be on an at-will basis, which means you and the company are free to
            terminate the employment relationship at any time for any reason.
            This letter is not a contract or guarantee of employment for a
            definite amount of time. As an employee of [company name], you are
            also eligible for our benefits program, which includes medical
            insurance, 401(k), and up to four weeks vacation time. Other
            benefits will be described in more detail in the employee handbook
            and orientation package. By signing and returning this letter you
            will confirm your acceptance of the offer. Please respond no later
            than July 1st, 2019. We look forward to having you on our team! If
            you have any questions, please feel free to reach out at your
            earliest convenience. Sincerely, [Your Signature] Neha Sharma HR -
            Head
          </ContentDiv>
        </HeaderPartDiv>
      </>
    )
  }
  const footer = () => {
    return (
      <>
        <CheckBoxFlex flexEnd alignCenter>
          <RadioDiv>Send the ‘Offer letters’ to </RadioDiv>

          <CheckBoxDiv>
            <Checkbox label={<RadioDiv>College</RadioDiv>} />
          </CheckBoxDiv>
          <CheckBoxDiv>
            <Checkbox label={<RadioDiv>Student</RadioDiv>} />
          </CheckBoxDiv>
        </CheckBoxFlex>
        <FooterFlex flexEnd>
          <Button.Secondary text="Cancel" width="88px" height="38px" />
          <Button.Primary text="Send" width="76px" height="38px" />
        </FooterFlex>
      </>
    )
  }
  return (
    <Drawer
      width="65%"
      title={'Preview Intent to Offer'}
      placement="right"
      visible={offerLetter}
      content={content()}
      footer={footer()}
      onClose={() => {
        setOfferLetter(false)
      }}
      closable
    />
  )
}

export default PreviewOfferLetter
